export const Caret = ({ isActive }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="7.41"
    viewBox="0 0 12 7.41"
  >
    <g transform={isActive ? 'translate(6 7.84)' : 'translate(-6 -7.84)'}>
      <path
        d="M7.41,7.84,12,12.42l4.59-4.58L18,9.25l-6,6-6-6Z"
        fill="#323a26"
      />
    </g>
  </svg>
);
